import { render, staticRenderFns } from "./StudentEnrollmentDialog.vue?vue&type=template&id=ee0882e8"
import script from "./StudentEnrollmentDialog.vue?vue&type=script&lang=js"
export * from "./StudentEnrollmentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports